import Service from '../../service/Service';
const service = new Service();

export function addDetails(thId, compref){
    // console.log(thId);
    if (compref.state.isLogin) {
         // (global.userAry['childData'] && global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList']==null) || (global.userAry['childData'] && global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'].length < 2 &&  global.userAry['childData']['UserChildList'][0] && global.userAry['childData']['UserChildList'][0].IsExpected && global.userAry['childData']['UserChildList'][0].IsExpected
        if(global.userAry['childData']['UserChildList']==null || ((global.userAry['childData']['UserChildList'].length > 0 && global.userAry['childData']['UserChildList'][0].IsExpected) || global.userAry['childData']['UserChildList'].length < 2)){
            service.showAlert("Please enter child details");
            window.location.href = global.redirect_url + 'my-account/myprofile?URL=' + global.currentURL;
        }else
            compref.setState({isshowDetails: true, insertThisTooth: thId, showChildrenList: true });
    }else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
    }
}

export function saveTeethData(compref) {
    if (global.ftk !== '') {
        var childId = compref.state.selectedChlId;
        var chlDOB = compref.state.selectedChlDOB;
        var thId = compref.state.insertThisTooth;
        var thName = document.querySelector('.tooth-nm').innerText;
        var comment = document.querySelector('textarea.details-txt').value;
        var date = document.querySelector('#teeth-date').value;
        var postData = {
    		"childId" : childId,
    		"comment" : comment,
    		"dateOfBirth" : chlDOB,
    		"toothDate" : date,
    		"toothId" : thId,
    		"toothName" : thName,
            "userId" : global.uID,
        };
        console.log("postData == ", postData);
        var url = global.api_ci_url + "BabyTeething/insertTeethData";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result'] == "success") {
				document.querySelector('.test-internet-error .save-success').innerHTML = "Congratulations!!<br>" + compref.state.selectedChlname + "’s " + thName + " has erupted";
                document.querySelector('.test-internet-error').style.display="block";
                setTimeout(() => {
                    document.querySelector('.test-internet-error').style.display="none";
                    compref.setState({isshowDetails: false});
                    compref.getChildData(childId);
                }, 3000)
            }
            else{
                service.showAlert("Please enter a date");
            }
            // eleRef.reloadData();
            // clearCommentPopupData();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
        return true;
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

export function likeArticle(artiID, artstatus, e, likecount){
    if (global.ftk !== '' && navigator.onLine) {
        if (artstatus == 1 && !document.querySelector("#" + e).className.includes('likedArticle')) {
            var postData = {
                "articleId" : artiID,
                "actionStatus" : artstatus
            }
            var url = global.api_ci_url + "BabyTeething/likeArticle";
            service.postServiceCall(url, postData).then((json) => {
                if (json['result'] == "success") {
                    // debugger;
                    document.querySelector("#" + e).classList.add('likedArticle');
                    document.querySelector("#" + e).nextSibling.firstChild.innerHTML = likecount + 1;
                }
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        }
    } else{
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

export function ViewCountArticle(artiID, articleUrl) {
    // alert("ViewCountArticle"+artiID);
    var postData = {
        "articleId" : artiID,
        "post_status" : "publish"
    }
    var url = global.api_ci_url + "BabyTeething/ViewArticle";
    service.postServiceCall(url, postData).then((json) => {
        window.location.href = articleUrl;
        console.log("view article : ",json);
    }).catch((error) => {
        console.error(error);
        service.hideLoader();
    });
}

export function changeData(compref, currmon, curryr){
    if(document.querySelector(".week-bar").classList.contains("monthbar")){
        // console.log("childChanged if");
        var a = document.querySelectorAll(".monthbar li");
        for(var i =0; i<a.length; i++){
            a[i].firstChild.children[0].classList.remove("weekcircle");
        }
        if(currmon > 36){
            compref.weekInfo(1, 36);
        } else if(currmon < 1)
            compref.weekInfo(1, 1);
        else{
            for(var i =0; i<a.length; i++){
                if(a[i].firstChild.children[0].innerText == currmon){
                    a[i].firstChild.children[0].classList.add("weekcircle");
                    break;
                }
            }
            compref.weekInfo(1, currmon);
        } 
    }
    else{
        // console.log("childChanged else");
        var a = document.querySelectorAll(".yearbar li");
        for(var i =0; i<a.length; i++){
            a[i].firstChild.children[0].classList.remove("weekcircle");
        }
        if(curryr >= 6 && curryr <= 12){
            // console.log("changeData 3");
            for(var i =0; i<a.length; i++){
                if(a[i].firstChild.children[0].innerText == curryr){
                    a[i].firstChild.children[0].classList.add("weekcircle");
                    break;
                }
            }
            compref.weekInfo(1, curryr);
        }
        else if(curryr < 6){
            // console.log("changeData 4");
            compref.weekInfo(1, 6);
        }
        else{
            // console.log("changeData 5");
            compref.weekInfo(1, 12);
        }
    }
}

export function getCurrentYear(dob) {
	var currentYr = (new Date()).getFullYear();
	var currentMn = (new Date()).getMonth() + 1;
	var currentDt = (new Date()).getDate();
	var childYr = (new Date(dob.replace(/-/g, '/'))).getFullYear();
	var childMn = (new Date(dob.replace(/-/g, '/'))).getMonth() + 1;
    var childDt = (new Date(dob.replace(/-/g, '/'))).getDate();
    var chlCurrentYear;
	if (currentYr == childYr) {
		chlCurrentYear = 1
	} else {
		var totalYears = currentYr - childYr;
		if (currentMn < childMn) {
			chlCurrentYear = totalYears
		} else if (currentMn > childMn) {
			chlCurrentYear = totalYears + 1
		} else if (currentMn == childMn) {
			if (currentDt < childDt) {
				chlCurrentYear = totalYears
			} else {
				chlCurrentYear = totalYears + 1
			}
		}
    }
    return chlCurrentYear;
}

export function readmore(compref){
    if(compref.state.isreadmore == false){
        compref.setState({isreadmore:true});
        document.querySelector(".toothTips").classList.remove("cropTip");
    } else {
        compref.setState({isreadmore:false});
        document.querySelector(".toothTips").classList.add("cropTip");
    }
}

export function monthbarScroll(compref){
    // alert("hi");
    if(window.outerWidth < 768){
        console.log("monthbarScroll");
        // console.log("halfwidth ",compref.state.halfwidth);
        // console.log("weekwd ",compref.state.weekwd);
        // console.log("weeks ",compref.state.weeks);
        // console.log("centerMonth ",compref.state.centerMonth);

        // var leftPos;
        // var ab;
        // var scroll_width = document.querySelector('.baby-size-weeks').outerWidth;
        var monthbar = document.querySelector('.week-bar'); //ab
        var monthbarli = document.querySelectorAll('.week-bar li');
        var leftPos = Math.ceil(document.querySelector('.weeks-section').scrollLeft);
        var a = compref.state.centerMonth;
        console.log("monthbarScroll1 ",compref.state.scrollwidth + leftPos," < ",monthbar.offsetWidth);
        if (leftPos !== 0 && (compref.state.scrollwidth + leftPos) < monthbar.offsetWidth) {
            var xyz = Math.ceil((leftPos) / compref.state.weekwd);
            console.log("monthbarScroll2", xyz);
            if (!monthbarli[xyz + a].classList.contains("sel-week") && !monthbarli[xyz + a].firstChild.children[0].classList.contains("weekcircle")) {
                console.log("monthbarScroll3");
                monthbarli[xyz + a].classList.add("sel-week");
                monthbarli[xyz + a].firstChild.children[0].classList.add("greycircle");
                monthbarli[xyz + a].firstChild.children[1].classList.add("wk-txt");
                if (monthbar.classList.contains("yearbar")) {
                    monthbarli[xyz + a].firstChild.children[1].innerHTML = "Years";
                } else {
                    monthbarli[xyz + a].firstChild.children[1].innerHTML = "Months";
                }
                for(let i=0; i<monthbarli.length; i++) {
                    if((xyz + a) != i) {
                        monthbarli[i].classList.remove('sel-week');
                        monthbarli[i].classList.remove('curr-week');
                        monthbarli[i].firstChild.children[0].classList.remove("greycircle");
                        // monthbarli[i].firstChild.children[1].classList.remove("wk-txt");
                        monthbarli[i].firstChild.children[1].innerHTML = "";
                    }
                }
            } else if (monthbarli[xyz + a].firstChild.children[0].classList.contains("weekcircle") && !monthbarli[xyz + a].classList.contains("curr-week")){
                monthbarli[xyz + a].classList.add("curr-week");
                monthbarli[xyz + a].firstChild.children[1].classList.add("currentweek");
                if (monthbar.classList.contains("yearbar")) {
                    monthbarli[xyz + a].firstChild.children[1].innerHTML = "Current<br />Years";
                } else {
                    monthbarli[xyz + a].firstChild.children[1].innerHTML = "Current<br />Months";
                }
                for(let i=0; i<monthbarli.length; i++) {
                    if((xyz + a) != i) {
                        monthbarli[i].classList.remove('sel-week');
                        // monthbarli[i].classList.remove('curr-week');
                        monthbarli[i].firstChild.children[0].classList.remove("greycircle");
                        // monthbarli[i].firstChild.children[1].classList.remove("wk-txt");
                        monthbarli[i].firstChild.children[1].innerHTML = "";
                    }
                }
            }
        }
        // console.log("leftPos ",leftPos);
    }
}
export function monthStrToNum(monthStr) {
	return new Date(monthStr + '-1-01').getMonth() + 1;
}



// WEBPACK FOOTER //
// src/shared/tools/baby-teething/TeethingActions.js